import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import ModalInner from "../../layoutItems/modalInner";

class GeneralAssemblyItemPopup extends React.Component {
    render() {
        return (
            <ModalInner title={this.props.translate("Report.Detail")} close={this.props.close}>
                <table style={{ width: "100%" }} className="table table-report-section-2 key-value liens-detail">
                    <tbody>
                        <tr>
                            <td><b>{this.props.translate("Report.GeneralAssemblies.MainTopics")}</b></td>
                            <td>{this.props.data.mainTopics}</td>
                        </tr>
                        <tr>
                            <td><b>{this.props.translate("Report.GeneralAssemblies.PresentationWay")}</b></td>
                            <td>{this.props.data.presentationWay}</td>
                        </tr>
                    </tbody>
                </table>
            </ModalInner>
        )
    }
}

export default withLocalize(GeneralAssemblyItemPopup);